import { createRouter, createWebHistory } from 'vue-router'

const Home = () => import('../views/Home.vue')
const BlogList = () => import('../views/BlogList.vue')
const BlogPost = () => import('../views/BlogPost.vue')

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/blog', name: 'BlogList', component: BlogList },
    { path: '/blog/:slug', name: 'BlogPost', component: BlogPost },
  ],
  // Ancoras da home (#recursos, #planos, #faq) continuam funcionando: ao
  // navegar pra uma rota com hash, rola até o elemento em vez de ir pro topo.
  scrollBehavior(to) {
    if (to.hash) return { el: to.hash, behavior: 'smooth' }
    return { top: 0 }
  },
})

export default router
